export const KeyCache = {
  INFO: 'INFO',
  MYCOUPON: 'my-coupon',
  IS_DISMISSED_UPGRADE_TIER: 'is_dismissed_upgrade_tier'
}
